export default "__VITE_ASSET__BZO9JcLr__"